import React, {useCallback} from 'react';
import PropTypes from 'prop-types';
import {useDispatch} from 'react-redux';
import {deleteItProcess} from '../../../../../../actions/ITProcess/itprocessactions';
import {clientSideEventNames} from '../../../../../../util/uiconstants';
import {labels} from '../../../../../../util/utils';
import BodySpecialDeleteItemModal from './BodySpecialDeleteItemModal';

function BodySpecialDeleteItProcess({
	engagementId,
	bodyId,
	itProcessId,
	button,
	itProcessName,
	isLoading,
	setIsLoading,
	show,
	onHide
}) {
	const dispatch = useDispatch();

	const handleOnDelete = useCallback(
		() =>
			dispatch(deleteItProcess(engagementId, bodyId, itProcessId)).then(() =>
				window.dispatchEvent(new CustomEvent(clientSideEventNames.getValidations))
			),
		[dispatch, engagementId, bodyId, itProcessId]
	);

	return (
		<BodySpecialDeleteItemModal
			name={itProcessName}
			title={button}
			onDelete={handleOnDelete}
			isLoading={isLoading}
			setIsLoading={setIsLoading}
			show={show}
			onHide={onHide}
		/>
	);
}

BodySpecialDeleteItProcess.propTypes = {
	engagementId: PropTypes.number.isRequired,
	bodyId: PropTypes.number.isRequired,
	itProcessId: PropTypes.number.isRequired,
	itProcessName: PropTypes.string.isRequired,
	button: PropTypes.string,
	isLoading: PropTypes.bool,
	setIsLoading: PropTypes.func.isRequired
};

BodySpecialDeleteItProcess.defaultProps = {
	button: labels.deleteItProcess,
	isLoading: false
};

export default BodySpecialDeleteItProcess;
